import { useState } from "react";
import { useMediaQuery, useSettings, useUpdateEffect } from "..";
import { TDevices } from "./useIsDevice.types";

export default function useIsDevice(device: TDevices) {
    const settings = useSettings();

    const getBreakpoint = () => {
        switch (device) {
            case "mobile":
                return "(max-width:" + settings?.breakpoints?.mobile?.value + "px)";
            case "tablet":
                return "(max-width:" + settings?.breakpoints?.tablet?.value + "px)";
        }

        //defaults to "desktop"
        return "(min-width:" + settings.breakpoints?.tablet?.value + "px)";
    };

    const [breakpoint, setBreakpoint] = useState<string>(getBreakpoint());

    useUpdateEffect(() => {
        setBreakpoint(getBreakpoint());
    }, [device]);

    return useMediaQuery(breakpoint);
}
